import request from "@/utils/request";

export function getWeather() {
  return request({
    url: "/weather/",
    method: "POST"
  });
}

export function getLocation() {
  return request({
    url: "/weather/location/",
    method: "POST"
  });
}

export function getStock() {
  return request({
    url: "/stock/",
    method: "POST"
  });
}

export function getTicketInfo(data) {
  return request({
    url: "/ticket/info/",
    method: "POST",
    data: data
  });
}
